module.exports = __webpack_public_path__ + "static/media/street_cleaning.1ac0bd83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parking_icons/street_cleaning.png
// module id = 1279
// module chunks = 0 1